import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <>
      {/* Hero with full-width background image */}
      <section className="relative w-full min-h-[70vh] md:min-h-[80vh] flex items-center justify-center overflow-hidden" data-id="element-114">
        <img src="https://cdn.magicpatterns.com/uploads/5idYWf8xNNcDnsKcj1u8MN/4c3bbe9331169a46c221997450121b53.jpg" alt="Maternidad" className="absolute inset-0 w-full h-full object-cover" data-id="element-115" />
        <div className="absolute inset-0 bg-black/40" data-id="element-116"></div>

        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto flex flex-col items-center" data-id="element-117">
          <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl text-white mb-8 leading-tight uppercase tracking-wide" data-id="element-118">
            Nadie te prepara para esto
          </h1>
          <p className="font-serif text-lg md:text-2xl text-white/90 mb-8 max-w-3xl leading-relaxed" data-id="element-119">
            Tu bebe no viene con un manual. Es normal que te surjan muchas dudas
            y miedos. A veces sentís que lo estas haciendo mal… y no sabés por
            qué
          </p>
          <p className="font-serif text-lg md:text-2xl text-white/90 mb-10 max-w-3xl leading-relaxed" data-id="element-120">
            Te encontrás buscando respuestas todo el tiempo
          </p>
          <div className="space-y-4 text-white/85 text-base md:text-lg font-light mb-10 max-w-2xl leading-relaxed" data-id="element-121">
            <p data-id="element-122"></p>
            <p data-id="element-123"></p>
          </div>
        </div>
      </section>

      {/* Product presentation below hero */}
      <section className="w-full bg-white py-14 md:py-20 px-6" data-id="element-124">
        <div className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-125">
          <p className="font-serif text-xl md:text-2xl text-charcoal-600 mb-5 max-w-2xl leading-relaxed" data-id="element-126">
            Y nadie te dice si lo estás haciendo bien… o no
          </p>

          <p className="text-charcoal-400 text-sm md:text-base mb-3 tracking-wider uppercase font-light" data-id="element-127">
            Por eso creamos
          </p>

          <span className="text-warm-500 tracking-[0.3em] uppercase mb-5 text-[32px] font-[700]" data-id="element-128">
            Florecer
          </span>

          <a href="https://checkout.aulamater.online/cart/44073141076067:1" className="block w-full max-w-xs mx-auto mb-8 transition-opacity duration-500 hover:opacity-90" data-id="element-129">
            <img src="https://cdn.magicpatterns.com/uploads/aS8TEinEsRuS6MDLyNf5B7/349bf724-620e-463d-a804-95c66235b1b4.png" alt="Florecer Ebook" className="w-full h-auto" data-id="element-130" />
          </a>

          <p className="font-serif text-xl md:text-2xl mb-7 max-w-2xl leading-relaxed text-[#A8B6A1]" data-id="element-131">
            Una guía clara para que sepas exactamente qué hacer en cada etapa de
            tu embarazo
          </p>

          <h3 className="font-serif md:text-3xl mb-5 max-w-2xl text-[16px] font-[300] text-[#020202]" data-id="element-132">
            No es que no puedas… es que nadie te enseñó
          </h3>

          <div className="space-y-3 text-charcoal-500 text-base md:text-lg font-light mb-7 max-w-2xl leading-relaxed" data-id="element-133">
            <p data-id="element-134"></p>
            <p data-id="element-135">
              Estás atravesando algo completamente nuevo… y nadie te dijo cómo
              se siente realmente.
            </p>
            <p data-id="element-136">
              Te llenan de información… pero no te ayudan a entender lo que te
              pasa.
            </p>
            <p data-id="element-137">Te sentis abrumada y desordenada.</p>
            <p data-id="element-138"></p>
            <p data-id="element-139">Y ahí es donde empieza la duda.</p>
          </div>

          <div className="space-y-3 text-charcoal-400 text-lg font-light mb-10 max-w-2xl leading-relaxed" data-id="element-140">
            <p data-id="element-141"></p>
            <p data-id="element-142"></p>
            <p data-id="element-143">Y aunque todos opinan… nadie te explica realmente qué hacer.</p>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-144">
            <CTAButton href="#compra" data-id="element-145">Acceder a la guía + Regalos</CTAButton>
            <p className="text-charcoal-300 text-sm tracking-wider uppercase mt-2" data-id="element-146">
              $19.990 ARS · Acceso inmediato
            </p>
          </div>
        </div>
      </section>
    </>;
}